import { render } from "./UIButton.vue?vue&type=template&id=6f6ceaa2&scoped=true"
import script from "./UIButton.vue?vue&type=script&lang=js"
export * from "./UIButton.vue?vue&type=script&lang=js"

import "./UIButton.vue?vue&type=style&index=0&id=6f6ceaa2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6ceaa2"]])

export default __exports__